// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__YgLQ6","content":"NotFound_content__HdO_w","title":"NotFound_title__mqpJp","subtitle":"NotFound_subtitle__1lSod"};